(() => {
  if (window.YogaSpaceNativeCart) return;
  const node = document.getElementById('ypc-native-cart-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch { return; }
  const request = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  const retired = code => /^YOGASPACE50(?:-VERIFY-20261001)?$/i.test(String(code));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style:'currency', currency:config.currency, minimumFractionDigits:0, maximumFractionDigits:2 }).format(cents / 100);
  const escape = value => String(value).replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  const yoga = element => Boolean(element.querySelector('a[href*="/products/yogaspace"]'));
  const price = variant => {
    if (!verified) return '<span>Updating price…</span>';
    const bundlePrice = window.CorkSpaceHalloween?.bundlePrice?.(variant);
    if (Number.isFinite(bundlePrice)) return `<del>${escape(money(variant.price))} ${escape(config.onceLabel)}</del><strong>${escape(money(bundlePrice))} ${escape(config.onceLabel)}</strong>`;
    return `${variant.compareAt > variant.price ? `<del>${escape(money(variant.compareAt))} ${escape(config.perYearLabel)}</del>` : ''}<strong>${escape(money(variant.price))} ${escape(config.onceLabel)}</strong>`;
  };
  const end = Date.parse(config.endsAt);
  const phaseReady = variants => Date.now() < end ? variants.every(variant => variant.compareAt > variant.price) : variants.every(variant => !variant.compareAt || variant.price >= variant.compareAt);
  let verified = phaseReady(config.variants);
  let hasYoga = false;
  let nextCheck = 0;
  let pending = Promise.resolve();
  let scheduled = false;
  let refreshedAfterEnd = false;
  function setPriceReady(button) {
    if (!button) return;
    if (!verified) { button.dataset.ypcPricePending='true'; button.disabled=true; }
    else if (button.dataset.ypcPricePending) { delete button.dataset.ypcPricePending; button.disabled=false; }
  }
  function unverified() {
    verified=false;
    window.dispatchEvent(new CustomEvent('yogaspace:native-prices-unverified'));
    schedule();
  }
  function render() {
    document.querySelectorAll('#cart-drawer-app .cd-cart-upsell-item').forEach(item => {
      if (!yoga(item)) return;
      const prices = item.querySelector('.cd-cart-upsell-item-prices');
      if (!prices) return;
      const practice = config.variants.find(variant => variant.title === 'Practice');
      if (!practice) return;
      const html = `<div class="ypc-cart-native-plan"><span>${escape(practice.title)}</span><span class="ypc-cart-native-price">${price(practice)}</span></div>`;
      if (prices.innerHTML !== html) prices.innerHTML = html;
      let badge = item.querySelector('.ypc-cart-upsell-offer');
      const earlyBird = verified && Date.now() < end && practice.compareAt > practice.price;
      if (earlyBird && !badge) {
        badge = document.createElement('span');
        badge.className = 'ypc-cart-upsell-offer';
        item.querySelector('.cd-cart-upsell-item-title')?.insertAdjacentElement('afterend', badge);
      }
      if (badge) {
        if (earlyBird) {
          if (badge.textContent !== config.earlyBirdLabel) badge.textContent = config.earlyBirdLabel;
        } else badge.remove();
      }
      let description = item.querySelector('.ypc-cart-upsell-description');
      if (!description) {
        description = document.createElement('p');
        description.className = 'ypc-cart-upsell-description';
        prices.insertAdjacentElement('beforebegin', description);
      }
      if (description.textContent !== config.description) description.textContent = config.description;
      item.classList.add('ypc-cart-native-upsell');
      setPriceReady(item.querySelector('.cd-cart-upsell-item-add')); 
      prices.classList.add('ypc-cart-native-plans');
    });
    document.querySelectorAll('#cart-drawer-app .cd-cart-upsell-detail').forEach(detail => {
      if (!yoga(detail)) return;
      const choice = detail.querySelector('select');
      const variant = config.variants[Number(choice?.value || 0)];
      const prices = detail.querySelector('.cd-cart-upsell-detail-pricing');
      if (!variant || !prices) return;
      setPriceReady(detail.querySelector('.cd-cart-upsell-detail-add'));
      const html = `<span class="ypc-cart-native-price">${price(variant)}</span>`;
      if (prices.innerHTML !== html) prices.innerHTML = html;
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; render(); });
  }
  async function refreshPrices() {
    const response = await request(`${root}products/yogaspace.js`, {cache:'no-store',headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Your plan price could not be checked. Please refresh and try again.');
    const product = await response.json();
    const variants = config.variants.map(old => {
      const variant = product.variants?.find(value => String(value.id) === String(old.id));
      if (!variant || !Number.isFinite(variant.price)) throw new Error('Your plan price could not be checked. Please refresh and try again.');
      return {id:variant.id,title:variant.public_title || variant.title,price:variant.price,compareAt:variant.compare_at_price || 0};
    });
    if (!phaseReady(variants)) { unverified(); throw new Error('Plan prices are updating. Please refresh shortly.'); }
    config.variants = variants; verified=true;
    document.querySelectorAll('[data-native-price-pending]').forEach(message=>message.remove());
    window.dispatchEvent(new CustomEvent('yogaspace:native-prices-updated',{detail:{currency:config.currency,variants}}));
    schedule();
    return variants;
  }
  async function clearRetiredCodes() {
    const response = await request(`${root}cart.js`, {cache:'no-store',headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Your cart could not be checked. Please try again.');
    const cart = await response.json();
    if (cart.currency !== config.currency) { unverified(); throw new Error('Your cart currency has changed. Refresh to confirm your prices.'); }
    if (!Array.isArray(cart.discount_codes)) throw new Error('Your cart discounts could not be checked. Please try again.');
    hasYoga = cart.items?.some(item => String(item.product_id) === '10265857949941') || false;
    if (!verified || !cart.discount_codes.some(discount => retired(discount.code))) return cart;
    const codes = cart.discount_codes.map(discount => discount.code).filter(code => !retired(code));
    const update = await request(`${root}cart/update.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:codes.join(',')})});
    if (!update.ok) throw new Error('Your cart could not be refreshed. Please try again.');
    const next = await update.json();
    if (next.currency !== config.currency) { unverified(); throw new Error('Your cart currency has changed. Refresh to confirm your prices.'); }
    document.dispatchEvent(new CustomEvent('yogaspace:offer-updated',{detail:next}));
    window.CD_REFRESHCART?.();
    return next;
  }
  const clean = () => { pending = pending.catch(()=>{}).then(clearRetiredCodes); return pending; };
  window.YogaSpaceNativeCart = { async prepare() { await clean(); const variants=await refreshPrices(); await clean(); return variants; }, refreshPrices };
  window.addEventListener('cartix:cartUpdated',event=>{ hasYoga=event.detail?.cart?.items?.some(item=>String(item.product_id)==='10265857949941') || false; schedule(); });
  window.addEventListener('click',event=>{
    if (!verified && hasYoga && event.target.closest?.('#cart-drawer-app .cd-cart-checkout-button, cart-drawer button[name="checkout"], a[href*="/checkout"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      const footer=document.querySelector('#cart-drawer-app .cd-cart-footer-inner');
      if (footer && !footer.querySelector('[data-native-price-pending]')) { const message=document.createElement('p');message.dataset.nativePricePending='';message.setAttribute('role','status');message.textContent='Plan prices are updating. Please refresh shortly.';footer.prepend(message); }
    }
  },true);
  window.addEventListener('corkspace:halloween-cart',schedule);
  document.addEventListener('change',schedule);
  new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
  setInterval(() => {
    if ((!verified || (Date.now() >= end && !refreshedAfterEnd)) && Date.now() >= nextCheck) {
      nextCheck=Date.now()+10000; unverified();
      clean().then(refreshPrices).then(variants => { refreshedAfterEnd = variants.every(variant => !variant.compareAt || variant.price >= variant.compareAt); }).catch(()=>{});
    }
  },1000);
  document.addEventListener('visibilitychange',()=>{ if (!document.hidden) clean().then(refreshPrices).then(clean).catch(()=>{}); });
  if (!verified) unverified();
  clean().then(refreshPrices).then(clean).catch(()=>{});
  schedule();
})();
